// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".waiting[data-v-57dc9318] {\n  width: 100%;\n  height: 485px;\n}\n.waiting .lobby-chat[data-v-57dc9318] {\n  height: 415px;\n}\n.waiting .lobby-chat[data-v-57dc9318] .body {\n  overflow-y: initial;\n}", ""]);
// Exports
module.exports = exports;
